import { MainBody } from '@app/components/LeadCard/ui/MainBody';
import { MainFooter } from '@app/components/LeadCard/ui/MainFooter';
import { MainHeader } from '@app/components/LeadCard/ui/MainHeader';

import type { FC } from 'react';

import './MainPanel.scss';

export const MainPanel: FC = () => (
  <main className="MainPanel">
    <MainHeader />
    <MainBody />
    <MainFooter />
  </main>
);
